import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react';
import { Button } from 'ksnm-common-ui/lib/Button';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Select } from 'ksnm-common-ui/lib/Select';
import { sortBy, uniqBy } from 'lodash-es';

import { controlGroupsStore } from '@stores/dictionaryStores/controlGroupsStore/controlGroupsStore';
import { controlsStore } from '@stores/dictionaryStores/controlsStore/controlsStore';
import { reportGroupsStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';

import styles from './Filter.module.scss';

export const Filter = observer((): JSX.Element => {
  const { controls, setFilters, filters, setSelectNode, setSelectedKeys } = controlsStore;
  const { reportGroups } = reportGroupsStore;
  const { controlGroups } = controlGroupsStore;

  const { reportGroup, controlGroup } = filters;

  const onClear = useCallback(() => {
    setFilters({});
    setSelectNode(null);
    setSelectedKeys([]);
  }, [setFilters, setSelectNode, setSelectedKeys]);

  const onChangeReportGroup = useCallback(
    (v) => {
      setFilters({ ...filters, reportGroup: v });
      setSelectNode(null);
      setSelectedKeys([]);
    },
    [filters, setFilters, setSelectNode, setSelectedKeys],
  );

  const onChangeControlGroup = useCallback(
    (v) => {
      setFilters({ ...filters, controlGroup: v });
      setSelectNode(null);
      setSelectedKeys([]);
    },
    [filters, setFilters, setSelectNode, setSelectedKeys],
  );

  const reportGroupItems = useMemo(
    () =>
      sortBy(
        uniqBy(
          controls.filter((item) => !!item.repGroupCode),
          'repGroupCode',
        ).map((control) => {
          const group = reportGroups.find((item) => item.code === control.repGroupCode);
          return {
            id: control.repGroupCode,
            name: group ? `${group.code} - ${group.name}` : '',
          };
        }),
        'name',
      ),
    [reportGroups, controls],
  );

  const controlGroupItems = useMemo(
    () =>
      sortBy(
        uniqBy(controls, 'ctrlGroupCode')
          .filter((item) => {
            if (reportGroup && item.repGroupCode !== reportGroup) {
              return false;
            }
            return !!item.ctrlGroupCode;
          })
          .map((control) => {
            const group = controlGroups.find((item) => item.ctrlGroupCode === control.ctrlGroupCode);

            return {
              id: control.ctrlGroupCode,
              name: group ? `${group.ctrlGroupCode} - ${group.ctrlGroupName}` : control.ctrlGroupCode,
            };
          }),
        'name',
      ),
    [controlGroups, controls, reportGroup],
  );

  return (
    <div className={styles.designFilters}>
      <div className={styles.items}>
        <Select
          items={reportGroupItems}
          placeholder="Группа отчетности"
          value={filters.reportGroup}
          onChange={onChangeReportGroup}
          size="small"
          showSearch
          className={styles.select}
        />
        <Select
          items={controlGroupItems}
          placeholder="Группа контролей"
          value={filters.controlGroup}
          onChange={onChangeControlGroup}
          size="small"
          showSearch
          className={styles.select}
        />
      </div>

      <Button onClick={onClear} disabled={!(reportGroup || controlGroup)} icon={<Icon name="stop" />}>
        Сбросить фильтры
      </Button>
    </div>
  );
});
